import axiosInstance from '@/libs/axios_config'
import { z } from 'zod'

const DWSSchema = z.object({
  receivingBenefit: z.boolean(),
})
export type DWSIncomeResponse = z.infer<typeof DWSSchema>

type CheckIncomeOptions = {
  program_id: number
  application_id: number
  include_spouse: boolean
  spouse_dob: string
}

export async function CheckDWSIncome({
  application_id,
  program_id,
  include_spouse,
  spouse_dob
}: CheckIncomeOptions) {
  const endpoint = `/scholar/family_application/document_verification/check_benefits`
  const response = await axiosInstance.post(endpoint, {
    program_id,
    application_id,
    include_spouse,
    spouse_dob
  })
  return DWSSchema.parse(response.data)
}

type VerifyResultOptions = {
  application_id: number
  activity_log_id: number
  dws_data_attested_by_applicant: number
}

const VerifyTaxComissionSchema = z.object({
  dws_data_attested_by_applicant: z
    .union([z.literal(0), z.literal(1)])
    .transform((value) => {
      if (value === 0) {
        return 'incorrect'
      }

      if (value === 1) {
        return 'correct'
      }

      throw new Error('Incorrect tax commission status update')
    }),
})

export async function VerifyTaxComissionResult({
  application_id,
  activity_log_id,
  dws_data_attested_by_applicant,
}: VerifyResultOptions) {
  const endpoint = `/family_application/document_verification/benefits_user_confirmation`
  const response = await axiosInstance.post(endpoint, {
    application_id,
    activity_log_id,
    dws_data_attested_by_applicant,
  })
  return VerifyTaxComissionSchema.parse(response.data)
}
